import http from '@/utils/http'
import { hasServices } from '@/utils/auth'
import i18n from '@/locales'
import { getRequestT } from '@/utils/utils'

export default {
  state: {
    companyInfo: {},
    workflow: {
      statistics: {
        // 未完成工单
        'nr-historic-process-instance': 0,
        // 待办工单
        'nr-process-task': 0,
      },
      // 已开启的工单keys
      enabledKeys: [],
    },
    // 自定义字典
    dictionary: {
      id: '',
      zh: {},
      en: {},
    },
    oem: {},
    license: {
      compute: {},
      service_numbers: [],
      status: {},
    },
    customer: {},
    customerCapability: {},
    enterpriseInfo: {},
    level: null,
    cities: [],
    billAccountInfo: {},
    alertresource: {
      data: [],
      total: 0,
    },
    alertrecords: {
      data: [],
      total: 0,
    },
    // 用户首次配置向导. show_guide是否显示配置向导,current_step当前配置步骤，steps配置向导包含的步骤
    user_guide_key: 'user_guide',
    user_guide: {
      first_time_setup: false,
      show_assistant_shortcut: false,
      current_step: 'welcome_screen',
      current_step_tips: '',
      steps: ['welcome_screen', 'cloudaccount_guide'],
    },
  },
  getters: {
    showWelcomeScreen (state) {
      return state.user_guide.first_time_setup && state.user_guide.current_step === 'welcome_screen'
    },
    logo (state) {
      if ((state.companyInfo.logo && state.companyInfo.logo !== '') && (state.companyInfo.logo_format && state.companyInfo.logo_format !== '')) {
        return `data:${state.companyInfo.logo_format};base64,${state.companyInfo.logo}`
      }
      return null
    },
    loginLogo (state) {
      if ((state.companyInfo.login_logo && state.companyInfo.login_logo !== '') && (state.companyInfo.login_logo_format && state.companyInfo.login_logo_format !== '')) {
        return `data:${state.companyInfo.login_logo_format};base64,${state.companyInfo.login_logo}`
      }
      return null
    },
    copyright (state) {
      if (state.companyInfo.copyright && state.companyInfo.copyright !== '') {
        return state.companyInfo.copyright
      }
      return null
    },
  },
  mutations: {
    SET_COMPANY_INFO (state, payload) {
      state.companyInfo = payload
    },
    SET_WORKFLOW_STATISTICS (state, payload) {
      state.workflow.statistics = payload
    },
    SET_WORKFLOW_ENABLED_KEYS (state, payload) {
      state.workflow.enabledKeys = payload
    },
    SET_DICTIONARY (state, payload) {
      const en = payload.value && payload.value.dictionary && payload.value.dictionary.en
      const zh = payload.value && payload.value.dictionary && payload.value.dictionary.zh
      const id = payload.id
      if (id) state.dictionary.id = id
      if (en) {
        state.dictionary.en = en
        i18n.mergeLocaleMessage('en', {
          dictionary: en,
        })
      }
      if (zh) {
        state.dictionary.zh = zh
        i18n.mergeLocaleMessage('zh-CN', {
          dictionary: zh,
        })
      }
    },
    SET_OEM (state, payload) {
      state.oem = payload
    },
    SET_LICENSE (state, payload) {
      state.license = payload
    },
    SET_CUSTOMER (state, payload) {
      state.customer = payload
    },
    SET_LEVEL (state, payload) {
      state.level = payload
    },
    SET_USER_VERIFY_URL (state, payload) {
      state.userVerifyUrl = payload
    },
    SET_CITIES (state, payload) {
      state.cities = payload
    },
    SET_BILL_ACCOUNT_INFO (state, payload) {
      state.billAccountInfo = payload
    },
    CLEAR_CUSTOMER (state) {
      state.customer = {}
    },
    SET_CUSTOMERCAPABILITY (state, payload) {
      state.customerCapability = payload
    },
    SET_ENTERPRISEINFO (state, payload) {
      state.enterpriseInfo = payload
    },
    SET_ALERTRESOURCE (state, payload) {
      state.alertresource = payload
    },
    SET_ALERTRECORDS (state, payload) {
      state.alertrecords = payload
    },
    SET_USER_GUIDE (state, payload) {
      state.user_guide = payload
    },
  },
  actions: {
    async fetchUserGuide ({ commit, state, dispatch }) {
      try {
        const res = await http.get(`/v1/parameters/${state.user_guide_key}`)
        await commit('SET_USER_GUIDE', res.data.value)
        return Promise.resolve(res.data)
      } catch (err) {
        if (!err.response || err.response.status !== 404) {
          throw err
        }
        try {
          const payload = Object.assign({}, state.user_guide)
          const ret = await http.get('/v1/cloudaccounts?limit=1&public_cloud=true')
          if (ret.data && ret.data.data && ret.data.data.length === 0) {
            payload.first_time_setup = true
            payload.show_assistant_shortcut = true
            await commit('SET_USER_GUIDE', Object.assign({}, payload))
          }
          return dispatch('createUserGuide', payload)
        } catch (e) {
          throw e
        }
      }
    },
    async createUserGuide ({ commit, state }, payload) {
      try {
        const res = await http.post('/v1/parameters', { name: state.user_guide_key, value: payload })
        return Promise.resolve(res.data)
      } catch (err) {
        throw err
      }
    },
    async updateUserGuide ({ state, commit }, payload) {
      try {
        const res = await http.put(`/v1/parameters/${state.user_guide_key}`, { value: payload })
        await commit('SET_USER_GUIDE', payload)
        return Promise.resolve(res.data)
      } catch (err) {
        throw err
      }
    },
    async nextUserGuide ({ state, dispatch }) {
      try {
        const payload = Object.assign({}, state.user_guide)
        const currentStepIndex = payload.steps.indexOf(payload.current_step)
        if (currentStepIndex >= 0 && currentStepIndex < payload.steps.length) {
          payload.current_step = payload.steps[currentStepIndex + 1]
        } else {
          return
        }
        return dispatch('updateUserGuide', payload)
      } catch (err) {
        throw err
      }
    },
    async finishFirstTimeUserGuide ({ state, commit, dispatch }) {
      const payload = Object.assign({}, state.user_guide)
      payload.first_time_setup = false
      return dispatch('updateUserGuide', payload)
    },
    async disableUserGuideAssistantShortcut ({ state, commit, dispatch }) {
      const payload = Object.assign({}, state.user_guide)
      payload.show_assistant_shortcut = false
      return dispatch('updateUserGuide', payload)
    },
    fetchCompayInfo ({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        http.get('/v1/infos/info').then(response => {
          const { data = {} } = response
          commit('SET_COMPANY_INFO', data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * @description 获取工单统计
     */
    fetchWorkflowStatistics ({ commit, rootGetters }) {
      if (!hasServices('itsm')) return Promise.resolve()
      return new Promise((resolve, reject) => {
        http.get('/v1/rpc/historic-process-instances/statistics', {
          params: {
            user_id: rootGetters.userInfo.id,
          },
        }).then(response => {
          const data = response.data
          commit('SET_WORKFLOW_STATISTICS', data)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * @description 获取开启工单类型
     */
    fetchWorkflowEnabledKeys ({ commit, rootGetters }) {
      if (!hasServices('itsm')) return Promise.resolve()
      return new Promise((resolve, reject) => {
        http.get('/v1/process-definitions', {
          params: {
            status: 'active',
          },
        }).then(response => {
          const data = (response.data.data || []).map(item => item.key)
          commit('SET_WORKFLOW_ENABLED_KEYS', data)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * @description 获取自定义字典
     */
    fetchDictionary ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        http.get('/v1/rpc/parameters/global-settings').then(response => {
          const data = response.data || {}
          commit('SET_DICTIONARY', data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * @description 获取oem信息
     */
    fetchOEM ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        http.get('/v1/infos/copyright').then(response => {
          const data = response.data || {}
          commit('SET_OEM', data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * @description 获取license信息
     */
    fetchLicense ({ commit }, payload) {
      return Promise.all([
        http.get('/v1/licenses/compute', {
          params: { $t: getRequestT() },
        }),
        http.get('/v1/licenses/compute/service_numbers', {
          params: { $t: getRequestT() },
        }),
        http.get('/v1/licenses/compute/status', {
          params: { $t: getRequestT() },
        }),
      ]).then(response => {
        commit('SET_LICENSE', {
          compute: response[0].data,
          service_numbers: response[1].data,
          status: response[2].data,
        })
      }).catch(error => {
        Promise.reject(error)
      })
    },
    /**
     * @description 获取customer信息
     */
    fetchCustomer ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        http.get('/v2/customers').then(response => {
          const data = response.data.data[0] || {}
          commit('SET_CUSTOMER', data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getCustomerCapabilities ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        http.get('/v2/customers/capabilities').then(response => {
          const { data } = response
          commit('SET_CUSTOMERCAPABILITY', data)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * @description 获取用户等级
     */
    async fetchLevel ({ commit }, payload) {
      try {
        const { data } = await http.get('/v2/customer-level')
        await commit('SET_LEVEL', data.customer_level)
        if (data.verify_url) {
          await commit('SET_USER_VERIFY_URL', data.verify_url)
        }
        return data
      } catch (error) {
        throw error
      }
    },
    /**
     * @description 获取城市列表
     */
    async fetchCities ({ commit }, payload) {
      try {
        const { data } = await http.get('/v2/cities?nation_code=CN')
        await commit('SET_CITIES', data.data)
        return data
      } catch (error) {
        throw error
      }
    },
    /**
     * @description 存储账单账号信息
     */
    async fetchBillAccountInfo ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        http.get('/v2/billing_accounts', {
          params: {
            id: payload,
          },
        }).then(response => {
          const data = response.data.data || []
          commit('SET_BILL_ACCOUNT_INFO', data[0] || {})
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * @description 清空Customer信息
     */
    clearCustomer ({ commit }) {
      commit('CLEAR_CUSTOMER')
    },
    /**
     * @description 获取监控策略告警数
     */
    fetchAlertresource ({ commit, rootGetters }, payload) {
      const params = { scope: rootGetters.scope, limit: 20, $t: getRequestT() }
      return new Promise((resolve, reject) => {
        http.get('/v1/alertresources', { params }).then(response => {
          const data = response.data || {}
          commit('SET_ALERTRESOURCE', data)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * @description 获取监控策略告警数
     */
    fetchAlertingrecords ({ commit, rootGetters }, payload) {
      const params = { scope: rootGetters.scope, limit: 20, alerting: true, $t: getRequestT() }
      return new Promise((resolve, reject) => {
        http.get('/v1/alertrecords', { params }).then(response => {
          const data = response.data || {}
          commit('SET_ALERTRECORDS', data)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    async getEnterPriseInfo ({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        try {
          http.get(`/v2/customers/${state.customerCapability.customer_id}/enterprise-info`).then(res => {
            const data = res.data || {}
            commit('SET_ENTERPRISEINFO', data)
            resolve(data)
          })
        } catch (error) {
          reject(error)
        }
      })
    },
    async getCities ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        try {
          http.get('/v2/cities?nation_code=CN').then(res => {
            commit('SET_CITIES', res.data.data)
            resolve(res.data.data)
          })
        } catch (error) {
          reject(error)
        }
      })
    },
  },
}
